import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { CartSidebar } from './CartSidebar';
import { ScrollToTop } from './ScrollToTop';
import './LayoutStyles.css';

/**
 * Layout wrapper for customer-facing pages
 * Includes header, main content area, footer, and global cart drawer
 */
export function CustomerLayout() {
    return (
        <div className="flex min-h-screen flex-col">
            <ScrollToTop />
            <Header />
            <CartSidebar />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

export default CustomerLayout;
